import { createModalContext } from 'modules/campaigns/lib/contexts';

export enum ModalType {
  SelectContentEditorModals = 'SelectContentEditorModals',
  ConfirmCustomFontModal = 'ConfirmCustomFontModal',
  DynamicContentBuilder = 'DynamicContentBuilder',
  SavedRowUnsavedChangesModal = 'SavedRowUnsavedChangesModal',
  SpamReport = 'spamReport',
  MovableInk = 'MovableInk',
}

export type ModalProps = Record<string, any>;

const PROVIDER_DEBUG_COMPONENT_NAME = 'TemplateEditorModalProvider';

export const { ModalContext, ModalProvider, useModalContext } = createModalContext<
  ModalType,
  ModalProps
>(PROVIDER_DEBUG_COMPONENT_NAME);
